<template>
    <app-layout v-if="isPageReady">
        <common-content-spacer height="medium">
            <common-content-spacer height="small">
                <div class="connection-header">
                    <div class="connection-header--item">
                        <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
                        <common-page-header class="connections__header" :heading="pageTitle"></common-page-header>
                    </div>
                    <div class="connection-header--item connections__search-members">
                        <span class="connection-header--item connections__search-members--text">
                            {{ $t('pages.network.connections.search_network') }}
                        </span>
                        <common-button
                            :label="$t('pages.network.connections.buttons.start_now')"
                            size="medium-small"
                            type="primary"
                            @click="openSearchAndAddMembersModal"
                        ></common-button>
                    </div>
                    <div class="connection-header--item connections__email-form-modal">
                        <common-button
                            :label="$t('pages.network.connections.buttons.send_network_message')"
                            size="small"
                            type="primary"
                            @click="toggleshowEmailForm()"
                        ></common-button>
                        <common-modal v-if="showEmailForm" @close="closeSendNetworkMessageModal()">
                            <email-form
                                :showBccWarning="true"
                                :showOpenSelectMemberModalButton="true"
                                @email-data="sendEmail"
                                @close="toggleshowEmailForm()"
                            ></email-form>
                        </common-modal>
                    </div>
                </div>
            </common-content-spacer>

            <my-connections ref="myConnections"></my-connections>
        </common-content-spacer>
        <search-and-add-members-modal
            :isOpen="isSearchAndAddMembersModalOpen"
            :practiceTypeValue="practiceTypeValue"
            @close="closeSearchAndAddMembersModal"
            @new-connection-added="newConnectionAdded"
        ></search-and-add-members-modal>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import MyConnections from '../../components/page-elements/network/MyConnections'
    import SearchAndAddMembersModal from 'components/page-elements/network/SearchAndAddMembersModal.vue'
    import EmailForm from '../../components/forms/connections/EmailForm.vue'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin],
        components: {
            AppLayout,
            MyConnections,
            SearchAndAddMembersModal,
            EmailForm,
        },

        data() {
            return {
                isSearchAndAddMembersModalOpen: false,
                showEmailForm: false,
                practiceTypeValue: PracticeTypeEnum.PHYSICIAN,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.network.connections.titles.my_connections')
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.network.connections.breadcrumbs.network'),
                        route: { name: 'network.connections' },
                    },
                ]
            },
        },
        methods: {
            sendEmail(event) {
                let bcc = []
                event.to.forEach((user) => {
                    bcc.push(user)
                })
                bcc.splice(event.to, 1)
                window.open(
                    `mailto:${event.to[0]}?bcc=${bcc || ''}&cc=${event.cc || ''}&subject=${event.subject}&body=${
                        event.message
                    }&from=${event.from}`,
                    '_blank',
                )
            },
            redirectToConnections() {
                this.$router.push({
                    name: `network.connections`,
                })
            },
            openSearchAndAddMembersModal() {
                this.isSearchAndAddMembersModalOpen = true
            },
            closeSearchAndAddMembersModal() {
                this.isSearchAndAddMembersModalOpen = false
            },
            newConnectionAdded() {
                this.$refs.myConnections.physicianFilter.offset = 0
                this.$refs.myConnections.ancillaryFilter.offset = 0
                this.$refs.myConnections.fetchData()
                this.closeSearchAndAddMembersModal()
            },
            toggleshowEmailForm() {
                this.showEmailForm = !this.showEmailForm
            },
            openSendNetworkMessageModal() {
                this.showEmailForm = true
            },
            closeSendNetworkMessageModal() {
                this.showEmailForm = false
            },
        },

        watch: {
            $route() {
                this.practiceTypeValue = this.$route.query.practiceType
            },
        },

        mounted() {
            if (this.$route.query?.openModal?.length) {
                if (this.$route.query?.openModal === 'connect') {
                    this.openSearchAndAddMembersModal()
                }
                if (this.$route.query?.openModal === 'networkMessage') {
                    this.toggleshowEmailForm()
                }
                const query = Object.assign({}, this.$route.query)
                delete query.openModal
                this.$router.replace({ query })
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .connection-header {
        @include breakpoint(tablet) {
            width: 100%;
            padding-right: 0;
        }

        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-right: 2.5rem;

        &--item {
            @include breakpoint(tablet) {
                width: 100%;
                margin-bottom: 20px;
                align-items: left;
            }
        }
    }
    .connections__search-members {
        @include breakpoint(tablet) {
            align-items: left;
            justify-content: flex-start;
            width: 150px;
        }

        display: flex;
        justify-content: center;
        align-items: center;

        & > span {
            @include breakpoint(tablet) {
                display: none;
            }
            margin-right: 20px;
            color: #333333;
            font-weight: 500;
        }
    }
    .connections__email-form-modal {
        @include breakpoint(tablet) {
            width: calc(100% - 150px);
            align-items: left;
            justify-content: flex-start;
        }

        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .email-form {
            right: 5%;
            top: 65px;
        }
    }
    .connections__header {
        max-width: 200px;
    }
</style>
